import { useState } from 'react'
import { ImageIcon, X } from 'lucide-react'
import AssetPickerModal from './AssetPickerModal'
import { normalizeImageKitUrl } from '@lic/media-urls'

interface AssetImageFieldProps {
  value: string
  onChange: (url: string) => void
  label?: string
  feature?: string
}

export default function AssetImageField({ value, onChange, label, feature }: AssetImageFieldProps) {
  const [pickerOpen, setPickerOpen] = useState(false)

  return (
    <>
      <div className="space-y-2">
        {value ? (
          <div className="relative inline-block">
            <img
              src={normalizeImageKitUrl(value)}
              alt={label ?? 'Image'}
              className="h-32 w-auto rounded border border-zinc-700 object-cover"
              onError={(e) => { ;(e.target as HTMLImageElement).style.display = 'none' }}
            />
            <button
              type="button"
              onClick={() => onChange('')}
              className="absolute top-1 right-1 bg-zinc-900/80 hover:bg-zinc-900 text-zinc-400 hover:text-white rounded p-0.5 transition-colors"
              title="Hapus gambar"
            >
              <X size={12} />
            </button>
          </div>
        ) : (
          <div className="h-32 w-32 rounded border border-dashed border-zinc-700 bg-zinc-800/50 flex items-center justify-center">
            <ImageIcon size={24} className="text-zinc-600" />
          </div>
        )}
        <button
          type="button"
          onClick={() => setPickerOpen(true)}
          className="text-xs bg-zinc-700 hover:bg-zinc-600 text-white px-3 py-1.5 rounded transition-colors"
        >
          {value ? 'Change' : 'Select Image'}
        </button>
      </div>

      {pickerOpen && (
        <AssetPickerModal
          onSelect={onChange}
          onClose={() => setPickerOpen(false)}
          feature={feature}
        />
      )}
    </>
  )
}
